import * as React from "react";
import { SVGProps } from "react";
export const SvgMenuLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21,16 L21,18 L3,18 L3,16 L21,16 Z M21,11 L21,13 L3,13 L3,11 L21,11 Z M21,6 L21,8 L3,8 L3,6 L21,6 Z"
      fill="currentColor"
      stroke="none"
      strokeWidth={1}
      fillRule="evenodd"
    />
  </svg>
);
